module.exports = __webpack_public_path__ + "static/media/kg.7699cfa0.svg";